export enum typeFormRequestEnum {
    IPTU = 1,
    ITBI = 2,
    SEAD = 3,
    INSCRICAO = 4,
    DEFAULT = 5,
    SEMURB = 6,
    ALVARA = 7,
    /**
     * Formulário digital montado pelo administrador no cadastro do assunto.
     * O valor 8 é contrato com a API (SolicitacaoModel.typeForm.DINAMICO): é por ele
     * que o servidor sabe que deve gravar o requerimento. Não trocar sem alterar a API.
     */
    DINAMICO = 8,
    DTI = 9,
} 
